import {
  FinanceApplicationsAgentStatusBreakdownModel,
  FinanceApplicationsReportMetricModel
} from '@/shared/models/finance-applications-agent-status-breakdown.model';
import {
  FinanceApplicationsAgentStatusBreakdownUiModel,
  FinanceApplicationsReportMetricUiModel
} from '@/shared/ui-models/finance-applications-agent-status-breakdown.ui-model';

function mapMetric(
  metric?: FinanceApplicationsReportMetricModel
): FinanceApplicationsReportMetricUiModel {
  return {
    count: metric?.count ?? 0,
    financedAmount: metric?.financedAmount ?? 0,
    durationMs: metric?.durationMs ?? 0,
    durationSamples: metric?.durationSamples ?? 0,
    averageDurationMs: metric?.averageDurationMs ?? 0
  };
}

function mapStatuses(statuses?: { [status: string]: FinanceApplicationsReportMetricModel }): {
  [status: string]: FinanceApplicationsReportMetricUiModel;
} {
  return Object.entries(statuses || {}).reduce(
    (acc, [status, metric]) => ({ ...acc, [status]: mapMetric(metric) }),
    {} as { [status: string]: FinanceApplicationsReportMetricUiModel }
  );
}

function mapToUi(
  report: FinanceApplicationsAgentStatusBreakdownModel
): FinanceApplicationsAgentStatusBreakdownUiModel {
  return {
    statuses: report?.statuses || [],
    agents: (report?.agents || []).map((agent) => ({
      agentId: agent.agentId,
      agentName: agent.agentName || '',
      agentEmail: agent.agentEmail || '',
      agentImageUrl: agent.agentImageUrl || '',
      total: mapMetric(agent.total),
      statuses: mapStatuses(agent.statuses),
      customerSources: (agent.customerSources || []).map((customerSource) => ({
        customerSource: customerSource.customerSource,
        total: mapMetric(customerSource.total),
        statuses: mapStatuses(customerSource.statuses)
      }))
    })),
    total: {
      total: mapMetric(report?.total?.total),
      statuses: mapStatuses(report?.total?.statuses)
    }
  };
}

const financeApplicationsAgentStatusBreakdownMapper = { mapToUi };

export default financeApplicationsAgentStatusBreakdownMapper;
